import { default as ExplorerComp } from "../components/explorer";
import PageWrap from "../ui/page-wrap";

export default function Explorer() {
  return (
    <PageWrap>
      <ExplorerComp />
    </PageWrap>
  );
}
